import React from "react";
import tw from "twin.macro";
import styled from "styled-components";

const Column = styled.div`
  ${tw`lg:w-1/2 max-w-xs `}
`;
const Card = styled.div`
  ${tw`flex items-center   text-center h-full lg:w-1/2  px-2 py-1`}
  .imageContainer {
    ${tw` items-start mt-3 rounded-full text-red-500  flex-shrink-0`}
    .image {
      ${tw`w-10 h-10 `}
    }
  }

  .textContainer {
    ${tw`mt-4 ml-2`}
  }

  .textContainerr {
    ${tw`mt-2 ml-1`}
  }

  .title {
    ${tw`mt-4  text-blue-900 font-semibold  pb-1  text-lg  h-5`}
  }

  .titlee {
    ${tw`mt-2  text-blue-900 font-semibold  pb-1  text-lg  h-3`}
  }

  .description {
    ${tw`mt-4 text-justify px-5  md:text-justify  sm:text-justify leading-relaxed`}
    font-size: 16px;
  }

  .descriptionn {
    ${tw`text-justify px-2  md:text-justify  sm:text-justify leading-relaxed`}
    font-size: 14px;
  }

  .link {
    ${tw`mt-auto inline-flex items-center  justify-end w-full text-sm font-bold text-blue-700 leading-none hocus:text-primary-900 transition duration-300`}
    .icon {
      ${tw`ml-2 w-4`}
    }}
`;


const ImageRow = tw.div`flex justify-evenly  flex-wrap	max-w-screen-xl  px-5 pt-0 pb-0`;

const ImageSpan = tw.span`lg:mx-1 md:mx-1 sm:mx-1  `;
const ImageColumn2 = tw(
  Column
)`flex  rounded-full p-0 sm:pl-5 sm:p-3 sm:w-24  sm:justify-center lg:p-2 lg:w-24 md:w-24 md:p-2 xs:w-18 xs:p-0 items-end sm:items-start xs:items-start`;

const Heading = tw.h5`text-left justify-center px-5 mt-5 text-lg font-bold text-gray-900`;

const LogoCard = ({data,imgArr,ispdf,card}) => {
  const Image = tw.img`bg-white	h-20 max-w-none	`;
  const PDfImage = tw.img`bg-white	h-10 max-w-none	`;
  return (
    <>
      <div   className={card !== "pdf" ?  "flex flex-col  justify-center lg:flex-row flex-wrap  max-w-screen-lg mx-auto": "flex flex-col  justify-center lg:flex-row flex-wrap  max-w-screen-lg mx-auto"}>

{data.map((item,index)=>{
   return <Card key={index}>
  <span className={card !== "pdf" ? "textContainer" : "textContainerr"}>
    <Heading>{item.heading}</Heading>
    {imgArr[index] && (
        <ImageRow>
          {Object.values(imgArr[index]).map((item2, imgIndex) => (
            <ImageSpan key={imgIndex}>
              <ImageColumn2>
       {!ispdf ? <Image src={item2} alt={`image${imgIndex + 1}`} />:         < PDfImage src={item2} alt={`image${imgIndex + 1}`} />}
              </ImageColumn2>
            </ImageSpan>
          ))}
        </ImageRow>
      )}
    <p className={card !== "pdf" ? "description" : "descriptionn"} >
      <span className={card !== "pdf" ? "title" : "titlee"}>{item.title}</span> 
        {item.description}
    </p>
  </span>
</Card>
})}
      </div>
    </>
  );
};

export default LogoCard;


